/** @enum {string} */
export const CAMPAIGN_TEMPLATE_ID = {
  WELCOME_VISITORS: 'welcome_message',
  SUBSCRIBE_NEWSLETTER: 'subscribe_newsletter',
  PRODUCT_RECOMMENDATION: 'product_recommendation',
  CART_BOOSTER: 'cart_booster'
};

export const CAMPAIGN_TEMPLATE = [
  {
    id: CAMPAIGN_TEMPLATE_ID.WELCOME_VISITORS,
    name: 'Welcome visitors',
    description: `Greet users with personalized messages, making their visit feel extra special`,
    image: 'https://cdnapps.avada.io/faq/campaign/welcome_visitors.png'
  },
  {
    id: CAMPAIGN_TEMPLATE_ID.SUBSCRIBE_NEWSLETTER,
    name: 'Subscribe newsletter',
    description: `Capture customer's email with hot deals, exclusive updates and rewards`,
    image: 'https://cdnapps.avada.io/faq/campaign/subscribe_newsletter.png'
  },
  {
    id: CAMPAIGN_TEMPLATE_ID.PRODUCT_RECOMMENDATION,
    name: 'Product recommendation',
    description: `Boost sales by recommending hot-deals, cross sell offer and discounts`,
    image: 'https://cdnapps.avada.io/faq/campaign/product_recommendation.png'
  },
  {
    id: CAMPAIGN_TEMPLATE_ID.CART_BOOSTER,
    name: 'Cart booster',
    description: `Convince your customers to buy, by offering them a small discount in the cart`,
    image: 'https://cdnapps.avada.io/faq/campaign/cart_booster.png'
  }
];

export const CAMPAIGN_MESSAGE_ID_PRODUCT_RECOMMENDATION = [
  'product-recommendation-show',
  'product-recommendation-question'
];

export const CAMPAIGN_MESSAGE_ID_CART_BOOSTER = [
  'cart-booster-question',
  'cart-booster-discount-welcome',
  'cart-booster-discount-code',
  'cart-booster-discount-usage-instruction'
];

export const CAMPAIGN_MESSAGE_ID = [
  ...CAMPAIGN_MESSAGE_ID_PRODUCT_RECOMMENDATION,
  ...CAMPAIGN_MESSAGE_ID_CART_BOOSTER
];
